import React from 'react'
import { InfoCircleOutlined } from '@ant-design/icons'
import { Tooltip } from 'antd'
import './org-dashboard.scss'

/**
 * An info icon that keyboard users can reach: it takes focus, and its definition opens on focus as well as hover.
 * The control is named "Definition" unless the caller names it, and the tooltip, which antd associates with the control
 * while it is open, is its description. A caller whose tooltip holds the only copy of a fact passes it as the name too,
 * so assistive technology gets the fact without having to open the tooltip. Definitions are sentences, so the tooltip
 * takes the wide long-copy width rather than antd's narrow default.
 */
export const DefinitionTooltip: React.FC<{ text: string; accessibleName?: string }> = ({
    text,
    accessibleName = 'Definition',
}) => (
    <Tooltip title={text} trigger={['hover', 'focus']} classNames={{ root: 'wide-tooltip' }}>
        <span className="org-dashboard-definition-tooltip" tabIndex={0} role="button" aria-label={accessibleName}>
            <InfoCircleOutlined aria-hidden="true" />
        </span>
    </Tooltip>
)
